<template>
  <div>
    <div
      v-if="loading"
      class="py-2"
    >
      <v-progress-circular
        indeterminate
        small
        color="primary"
      />
    </div>
    <div v-else-if="errMsg">
      {{ errMsg }}
    </div>
    <div v-else-if="parcel">
      <div class="mb-2">
        <KImg
          v-if="parcel.carrier"
          :src="`/static/images/carrier/${parcel.carrier}.png`"
          width="20"
        />
        <span
          v-if="parcel.carrierName"
          class="caption"
        >{{ parcel.carrierName }}</span>

        {{ parcel.trackingNo }}
      </div>
      <v-layout
        v-for="(tpItem, i) in parcel.extraInfo.tpTaobaoTradeItems"
        :key="i"
        class="mb-2"
      >
        <div>
          <KImg
            :src="tpItem.itemPic"
            width="60"
            class="rounded"
          />
        </div>
        <v-flex class="pl-2 caption">
          <v-layout
            column
            style="height: 100%;"
          >
            <div>
              <TraPlatformIcon
                :tpttPlatform="tpItem.traPlatform"
              />
              {{ tpItem.itemName }}
            </div>
            <v-spacer />
            <div class="mt-1">
              品名：{{ tpItem.itemTwName }}
              <v-btn
                small
                color="primary"
                @click="showAttachTrackingNoDialog = true; tiid = tpItem.tiid"
              >
                修改品名
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <div />

    <AttachTrackingNoDialog
      :propShowForm.sync="showAttachTrackingNoDialog"
      :propModel="parcel"
      :tiid="tiid"
      operationType="updateCid"
      @reload="success"
    />
  </div>
</template>
<script>
import TraPlatformIcon from '@g/components/TraPlatformIcon'
import AttachTrackingNoDialog from '../../parcel/AttachTrackingNoDialog/index.vue'

export default {
  components: {
    TraPlatformIcon,
    AttachTrackingNoDialog,
  },
  props: {
    comment: Object,
  },
  data () {
    return {
      parcel: null,
      errMsg: '',
      loading: false,

      showAttachTrackingNoDialog: false,
      tiid: '',
    }
  },
  computed: {
    user () {
      return this.$store.state.userData
    },
    trackingNo () {
      let s = this.comment.content.match(/\$\[.*?-(.+)\]/)[1]
      if (s[0] === '<') {
        s = s.match(/>([0-9A-Za-z]+)</)[1]
      }
      return s
    },
  },
  mounted () {
    this.fetchParcel()
  },
  methods: {
    async fetchParcel () {
      try {
        this.loading = true
        const res = await this.$store.dispatch('search/search', {
          mixed: this.trackingNo
        })
        if (res.data.name === 'jyorder-view' || res.data.name === 'jyorder-index') {
          this.errMsg = `${this.trackingNo} 包裹已打包`
        } else if (res.data.name === 'parcel-view') {
          this.parcel = (await this.$store.dispatch('parcel/formatParcelList', [res.data.model]))[0]
        } else {
          this.errMsg = `找不到包裹 ${this.trackingNo}`
        }
      } finally {
        this.loading = false
      }
    },
    success () {
      this.$snackbar('修改成功，稍候生效')
      this.fetchParcel()
    },
  },
}
</script>
